import type { EventName } from "@lit/react";
import { Details as DetailsElement, type DetailsEventMap as _DetailsEventMap, } from "@vaadin/details/vaadin-details.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DetailsElement, };
export type DetailsEventMap = Readonly<{
    onOpenedChanged: EventName<_DetailsEventMap["opened-changed"]>;
}>;
const events = { onOpenedChanged: "opened-changed" } as DetailsEventMap;
export type DetailsProps = WebComponentProps<DetailsElement, DetailsEventMap>;
export const Details = createComponent({
    elementClass: DetailsElement, events, react: React, tagName: "vaadin-details"
});
